import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";

function CateringBusinessDetails({ allData }) {
  console.log(allData);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the items table
  const itemsColumns = [
    {
      title: "Item Name",
      dataIndex: "itemName",
      key: "itemName",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Price Per Unit",
      dataIndex: "pricePerUnit",
      key: "pricePerUnit",
    },
    {
      title: "Actual Cost",
      dataIndex: "actualCost",
      key: "actualCost",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
  ];

  // Render function for the items table
  const renderItemsTable = (items, index) => {
    return (
      <>
        <Table
          dataSource={items}
          columns={itemsColumns}
          pagination={false}
          rowKey={(record) => record.id}
        />
      </>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
              <div className="card shadow-sm">
                <div className="card-body p-3">
                  <h5 className="card-title mb-2">{item?.catering?.name}</h5>
                  <p className="mb-1">Number of Plate: {item?.catering?.numberOfPlate}</p>
                  <p className="mb-1">Per Plate Charge: {item?.catering?.perPlateCharge}</p>
                  <p className="mb-1">Number of Month: {item?.catering?.numberOfMonth}</p>
                  <p className="mb-3">Total Amount: {item?.catering?.totalReceiptAmount}</p>
                  {item.items && item.items.length > 0 ? (
                    renderItemsTable(item.items, index)
                  ) : (
                    <div className="border rounded p-4 mb-2">
                      <p>No items available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CateringBusinessDetails;
